import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "name", "value", "disabled", "min", "max"]
const _hoisted_3 = {
  key: 1,
  class: "error-message"
}

import { useIdGenerator } from '@/shared/designsystem/useIdGenerator';
import { Ref, ref, watch } from 'vue';
import { useVModel } from '@vueuse/core';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-date-picker',
},
  __name: 'date-picker',
  props: {
  id: {
    type: String,
  },
  label: {
    type: String,
  },
  name: {
    type: String,
    default: '',
  },
  modelValue: {
    type: Date,
    required: true,
  },
  min: {
    type: Date,
  },
  max: {
    type: Date,
  },
  errorMessage: {
    type: String,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  hideLabel: {
    type: String,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {



const props = __props;

const { inputId } = useIdGenerator(props.id);

const emit = __emit;
const value = useVModel(props, 'modelValue', emit);

const minDate = ref<Date>();
const maxDate = ref<Date>();
const dateValueStr = ref('');
const dateError = ref('');

watch(
  () => props.errorMessage,
  () => (dateError.value = props.errorMessage || ''),
  { immediate: true },
);

watch(
  value,
  () => {
    if (!value.value) {
      return;
    }
    if (!(value.value instanceof Date)) {
      // This is needed to make the storybook work because the storybook control passes a unix timestamp
      dateValueStr.value = formatDate(new Date(value.value));
    } else if (!Number.isNaN(value.value.getTime())) {
      dateValueStr.value = formatDate(value.value);
    }
  },
  { immediate: true },
);

watch(
  () => props.min,
  () => {
    if (!(props.min instanceof Date) && props.min !== undefined) {
      minDate.value = new Date(props.min);
    } else {
      minDate.value = props.min;
    }
  },
  { immediate: true },
);

watch(
  () => props.max,
  () => {
    if (!(props.max instanceof Date) && props.max !== undefined) {
      maxDate.value = new Date(props.max);
    } else {
      maxDate.value = props.max;
    }
  },
  { immediate: true },
);

function handleInput(strValue: string) {
  const dateVal = new Date(strValue);
  value.value = dateVal;
}

function formatDate(date: Date | undefined) {
  if (date && date instanceof Date && !Number.isNaN(date.getTime())) {
    return date.toJSON().slice(0, 10);
  }
  return '';
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["n-input", { 'has-error': dateError.value }])
  }, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _unref(inputId),
          class: _normalizeClass({ 'sr-only': __props.hideLabel })
        }, _toDisplayString(__props.label), 11, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      class: "control",
      type: "date",
      id: _unref(inputId),
      name: __props.name,
      value: dateValueStr.value,
      disabled: __props.disabled,
      min: formatDate(minDate.value),
      max: formatDate(maxDate.value),
      onInput: _cache[0] || (_cache[0] = (e) => handleInput((e.target as HTMLInputElement).value))
    }, null, 40, _hoisted_2),
    (dateError.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(dateError.value), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})